export enum DynamicLayoutLevels {
  Container = 1,
  Main = 2,
  Inner = 3,
}
